import { Routes } from '@angular/router';

import { LAB_ROUTES } from '@lab/lab.routes';
import { applicationRoutes } from './app/application.routes';
import { environment } from './environments/environment';
import { mpsRoutes } from './mps/routes/mps.routes';

export const globalRoutes: Routes = [
  ...applicationRoutes,
  ...mpsRoutes,
  ...(environment.mpsKit.enableLab ? LAB_ROUTES : []), //@MPS-KIT::TODO:add LAB_ROUTES
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
